module.exports = __webpack_public_path__ + "static/media/sex-artwork.b39a1bd1.jpg";